export default __webpack_public_path__ + "media/images/front/about/about_page_03_lg-3c4dc50b7a7835cc5855e7101f023394.jpg";